import React from 'react'

const  SyncIcon = ({height}) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height={height}
    version="1"
    viewBox="0 0 120 120"
  >
    <path
      d="M483 1065c-74-20-148-60-199-107-45-41-53-65-32-86 20-20 38-14 81 24 22 20 69 50 106 68 60 28 75 31 162 31 90 0 99-2 171-37 47-24 91-55 117-84 44-47 95-145 105-201l6-33H880l76-115c43-63 80-115 84-115s41 52 84 115l76 115h-119l-11 55c-55 264-332 438-587 370zM91 721L10 600h106l10-69c44-278 321-465 587-396 72 19 146 56 192 96 36 32 44 56 23 77-19 19-36 15-76-18-20-16-64-42-97-57-52-24-72-28-155-28-86 0-101 3-162 32-37 17-87 50-112 74-56 50-113 162-122 236l-6 52 66 3 66 3-79 119-79 118-81-121z"
      transform="matrix(.1 0 0 -.1 0 120)"
    ></path>
  </svg>
  );
}
export default SyncIcon;